import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { EndPoints } from "../../../../endPoints/endPoints";
import { IWorkCost, IWorkCostEdit, IWorkCostNew } from "./IWorkCost";

export const workCostApi = createApi({
  reducerPath: "work_cost",
  baseQuery: fetchBaseQuery({
    baseUrl: EndPoints.WORKCOST,
  }),
  tagTypes: ["work-costs", "work-cost"],
  endpoints: (builder) => ({
    addWorkCost: builder.mutation<any, IWorkCostNew>({
      query(body) {
        return {
          url: "",
          method: "POST",
          credentials: "include",
          body,
        };
      },
      invalidatesTags: ["work-costs"],
    }),
    getWorkCost: builder.query<IWorkCost[], number>({
      query(id) {
        return {
          url: `/${id}`,
          method: "GET",
          credentials: "include",
        };
      },
      providesTags: ["work-costs"],
    }),
    editWorkCost: builder.mutation<IWorkCostEdit, IWorkCostEdit>({
      query({ id, ...body }) {
        return {
          url: `/${id}`,
          method: "PUT",
          credentials: "include",
          body,
        };
      },
      invalidatesTags: ["work-costs", "work-cost"],
    }),
    deleteWorkCost: builder.mutation<string, number>({
      query(id) {
        return {
          url: `/${id}`,
          method: "DELETE",
          credentials: "include",
        };
      },
      invalidatesTags: ["work-costs"],
    }),
  }),
});

export const {
  useAddWorkCostMutation,
  useGetWorkCostQuery,
  useEditWorkCostMutation,
  useDeleteWorkCostMutation
} = workCostApi;
